import type { IconProps as TablerIconProps } from "@tabler/icons-react";
import type { CoreProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export interface IconProps extends TablerIconProps, CoreProps {
  icon: React.ComponentType<TablerIconProps>;
}

export function Icon({ icon: IconComp, testId, view = "all", ...rest }: IconProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <IconComp data-testid={testId} {...rest} />;
}
